var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPodcastOpen = function SvgPodcastOpen(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3313_14640)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3313_14640",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3997 0.750977H0.399704V41.4589H40.3997V0.750977Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3313_14640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6185 2.47621L4.3795 3.02298C2.18168 3.06145 0.431097 4.87918 0.46946 7.083L0.997373 37.4097C1.03574 39.6135 2.84851 41.369 5.04633 41.3304L36.2854 40.7837C38.4832 40.7454 40.2338 38.9275 40.1954 36.7237L39.6675 6.39693C39.629 4.19311 37.8163 2.43774 35.6185 2.47621Z",
    fill: "#D0CDB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4823 4.90165L6.82474 5.38573C5.83573 5.40305 5.04797 6.22102 5.06522 7.21274L5.55493 35.3448C5.5722 36.3366 6.38795 37.1266 7.37696 37.1092L35.0345 36.6251C36.0234 36.6077 36.8113 35.7898 36.7939 34.798L36.3042 6.66598C36.2871 5.67426 35.4712 4.88435 34.4823 4.90165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3313_14640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9002 0.750977H13.7658C12.3919 0.750977 11.2782 1.86774 11.2782 3.24534C11.2782 4.62294 12.3919 5.7397 13.7658 5.7397H26.9002C28.2739 5.7397 29.3877 4.62294 29.3877 3.24534C29.3877 1.86774 28.2739 0.750977 26.9002 0.750977Z",
    fill: "#D0CDB1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.4946 33.0783C27.5395 33.0783 32.4399 28.1645 32.4399 22.1031C32.4399 16.0417 27.5395 11.1279 21.4946 11.1279C15.4497 11.1279 10.5493 16.0417 10.5493 22.1031C10.5493 28.1645 15.4497 33.0783 21.4946 33.0783Z",
    fill: "#477B32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3005 32.0812C26.3454 32.0812 31.2457 27.1675 31.2457 21.106C31.2457 15.0446 26.3454 10.1309 20.3005 10.1309C14.2555 10.1309 9.35518 15.0446 9.35518 21.106C9.35518 27.1675 14.2555 32.0812 20.3005 32.0812Z",
    fill: "#477B32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3381 22.2802C19.8841 22.2796 19.4489 22.0986 19.1279 21.7767C18.8069 21.4548 18.6264 21.0184 18.6259 20.5632V16.8351C18.6259 16.3797 18.8063 15.943 19.1274 15.621C19.4485 15.2991 19.884 15.1182 20.3381 15.1182C20.7923 15.1182 21.2277 15.2991 21.5489 15.621C21.8699 15.943 22.0504 16.3797 22.0504 16.8351V20.5632C22.0498 21.0184 21.8693 21.4548 21.5483 21.7767C21.2273 22.0986 20.7921 22.2796 20.3381 22.2802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3386 23.7037C19.3788 23.7025 18.4586 23.3198 17.78 22.6393C17.1013 21.9587 16.7196 21.036 16.7185 20.0736C16.7185 19.9956 16.7494 19.9207 16.8044 19.8655C16.8595 19.8103 16.9341 19.7793 17.012 19.7793C17.0898 19.7793 17.1645 19.8103 17.2195 19.8655C17.2746 19.9207 17.3055 19.9956 17.3055 20.0736C17.3055 20.8803 17.6251 21.6538 18.1939 22.2243C18.7627 22.7946 19.5342 23.1151 20.3386 23.1151C21.1429 23.1151 21.9145 22.7946 22.4832 22.2243C23.0522 21.6538 23.3716 20.8803 23.3716 20.0736C23.3716 19.9956 23.4026 19.9207 23.4576 19.8655C23.5127 19.8103 23.5873 19.7793 23.6651 19.7793C23.7431 19.7793 23.8178 19.8103 23.8727 19.8655C23.9278 19.9207 23.9587 19.9956 23.9587 20.0736C23.9577 21.036 23.576 21.9587 22.8972 22.6393C22.2186 23.3198 21.2984 23.7025 20.3386 23.7037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3385 27.0392C20.2607 27.0392 20.186 27.0081 20.131 26.953C20.0759 26.8978 20.045 26.8229 20.045 26.7449V23.5072C20.045 23.4292 20.0759 23.3544 20.131 23.2991C20.186 23.244 20.2607 23.2129 20.3385 23.2129C20.4163 23.2129 20.4911 23.244 20.546 23.2991C20.6012 23.3544 20.632 23.4292 20.632 23.5072V26.7449C20.632 26.8229 20.6012 26.8978 20.546 26.953C20.4911 27.0081 20.4163 27.0392 20.3385 27.0392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6634 27.0916H18.0132C17.9353 27.0916 17.8607 27.0607 17.8056 27.0054C17.7506 26.9501 17.7196 26.8753 17.7196 26.7973C17.7196 26.7192 17.7506 26.6444 17.8056 26.5891C17.8607 26.5339 17.9353 26.5029 18.0132 26.5029H22.6634C22.7412 26.5029 22.8158 26.5339 22.8709 26.5891C22.9259 26.6444 22.9569 26.7192 22.9569 26.7973C22.9569 26.8753 22.9259 26.9501 22.8709 27.0054C22.8158 27.0607 22.7412 27.0916 22.6634 27.0916Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3313_14640",
    x: 11.2782,
    y: 0.750977,
    width: 18.8175,
    height: 6.40421,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.707965,
    dy: 1.41593
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454199 0 0 0 0 0.435399 0 0 0 0 0.259915 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3313_14640"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3313_14640",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3313_14640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40.708,
    fill: "white",
    transform: "translate(0.399994 0.753906)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPodcastOpen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "podcast_open.13371ba37ca307edd60db76724352b96.svg";